import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=5b16289a&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=5b16289a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16289a",
  null
  
)

export default component.exports